import React from 'react'
import styled from 'styled-components'
import { ReportFirst } from '../Components/Reports/ReportFirst'
import { TsActivityComponent } from './TsActivity'
import { SelectedStaffProvider } from '../context/selectedStaff'
import { colors } from '../Shared/colors'
import { decryptData } from '../services/crypto'

export const ReportsComponent = () => {
  // Check if user is TS
  let role = null;
  let storedStaffRole = localStorage.getItem("role");
  
  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  // TS users see TS Activity, others see Activity Sales
  const isTS = role === "ts";

  return (
    <Main>
      <SelectedStaffProvider>
        {isTS ? <TsActivityComponent /> : <ReportFirst />}
      </SelectedStaffProvider>
    </Main>
  )
}


const Main = styled.div`
background-color: ${colors.inputWhite};
min-height: calc(100vh - 10vh);
margin-top: 10vh;
display: flex;
padding-top: 2em;
flex-direction: column;
justify-content: center;
align-items: center;
`